/**
 * Detects the folder this build is deployed under (e.g. "" for root, "/new" for /new/).
 * Works with homepage: "." so the same build can be uploaded to multiple Hostinger paths.
 */
export function getBasename() {
  const scripts = document.getElementsByTagName("script");

  for (const script of scripts) {
    const src = script.getAttribute("src");
    if (src && src.includes("/static/js/")) {
      const pathname = new URL(src, window.location.href).pathname;
      return pathname.replace(/\/static\/js\/.*$/, "");
    }
  }

  return "";
}

export function setupBaseHref() {
  const basename = getBasename();
  const baseHref = basename ? `${basename}/` : "/";

  if (!document.querySelector("base")) {
    const base = document.createElement("base");
    base.href = baseHref;
    document.head.insertBefore(base, document.head.firstChild);
  }
}